define('v3/Pages/WayOfWork/Components/WowCard/WowCard.Component',[
	'knockout',
	'lodash',
	'v3/Common/Services/Frontend/Frontend.Service',
	'text!v3/Pages/WayOfWork/Components/WowCard/WowCard.Component.html',
	'v3/Common/Bindings/HeightAnimation.Binding'
], function (ko, _, frontend, htmlString) {
	function validateParams (params) {
		if (!params.cardContent) {
			throw new Error('params.cardContent is expected.');
		}
		if (!ko.isObservable(params.cardContent.isCurrentSlideActive)) {
			throw new Error('params.cardContent.isCurrentSlideActive as observable is expected.');
		}
		if (!params.subjectCategory) {
			throw new Error('params.subjectCategory is expected.');
		}
		if (!ko.isObservable(params.subjectCategory)) {
			throw new Error('params.subjectCategory is not observable.');
		}
	}

	function WowCardViewModel (params) {
		var self = this;

		validateParams(params);

		var isCurrentSlideActive = params.cardContent.isCurrentSlideActive;
		self.cardContent = params.cardContent;
		self.showInstruction = false;
		self.showMoreInformation = ko.observable(false);
		self.isShowingSteps = ko.observable(true);
		self.isShowingCurrentProgress = ko.observable(false);
		self.progressText = ko.pureComputed(function () {
			return _.round(self.cardContent.progress(), 2) + ' ' + self.cardContent.progressText;
		});
		self.notStarted = ko.computed(function () { return self.cardContent.progress() === 0; });
		self.hasSubjectCategory = ko.computed(function () { return params.subjectCategory() !== undefined; });

		self.progressCssClass = ko.pureComputed(function () {
			var progress = self.cardContent.progress();
			var target = self.cardContent.target();

			if (progress === 0) {
				return 'not-started';
			}
			if (progress < target) {
				return 'below-target';
			}
			if (progress === target) {
				return 'on-target';
			}
			if (progress > target) {
				return 'above-target';
			}
			return '';
		});

		self.openVideo = function () {
			frontend.modal.show({
				require: 'v3/Common/Components/VideoPlayer/VideoPlayer.Component',
				params: { autoplay: true, sources: params.cardContent.videoSources },
				backgroundClass: 'backdropBlack fullscreen-video',
				modalClass: 'modal full videos',
				template: 'wowVideoTemplate'
			});
		};

		self.openElearning = function () {
			window.open(params.cardContent.elearningSource, '_blank');
		};

		self.openPlanMeeting = function () {
			window.open(self.cardContent.planMeeting, '_blank');
		};

		var isCurrentSlideActiveSubscription = isCurrentSlideActive.subscribe(function () {
			if (!isCurrentSlideActive()) {
				self.showMoreInformation(false);
			}
		});

		if (self.cardContent.hasVideo || self.cardContent.hasPlanMeeting || self.cardContent.hasELearning) {
			self.showInstruction = true;
		}

		self.moreInfoToggle = function () {
			self.showMoreInformation(!self.showMoreInformation());
		};

		self.showProgress = function () {
			self.isShowingSteps(false);
			self.isShowingCurrentProgress(true);
		};

		self.showHowTo = function () {
			self.isShowingSteps(true);
			self.isShowingCurrentProgress(false);
		};

		setTimeout(function () {
			if (typeof params.afterRender === 'function') {
				params.afterRender();
			}
		}, 0);

		self.dispose = function () {
			isCurrentSlideActiveSubscription.dispose();
		};
	}

	return { viewModel: WowCardViewModel, template: htmlString };
});

